import confirmDialog from 'helpers/confirmDialog';
import { adminPaymentGatewaysConstants } from '_store/_constants';

import alertActionCreators from '../alert.actions';
import service from '../../../services/adminPaymentGateways.service';

const deletePaymentMethod = id => {
  return dispatch => {
    confirmDialog.warning({
      title: 'Exclusão de Método de Pagamento',
      message:
        'Tem certeza que deseja excluir este método de pagamento? Esta operação não pode ser revertida.',
      confirmButtonText: 'Sim, deletar!',
      icon: 'warning',
      onConfirm: () => {
        dispatch(request(id));

        service.removePaymentMethod(id).then(
          () => {
            dispatch(success(id));
            dispatch(
              alertActionCreators.success('Método de pagamento excluído com sucesso!'),
            );
          },
          error => {
            dispatch(failure(error));
          },
        );
      },
      onCancel: () => {},
    });
  };

  function request(id) {
    return {
      type: adminPaymentGatewaysConstants.PAYMENT_METHOD_DELETE_REQUEST,
      id,
    };
  }

  function success(id) {
    return {
      type: adminPaymentGatewaysConstants.PAYMENT_METHOD_DELETE_SUCCESS,
      id,
    };
  }

  function failure(error) {
    return {
      type: adminPaymentGatewaysConstants.PAYMENT_METHOD_DELETE_FAILURE,
      error,
    };
  }
};

export default deletePaymentMethod;
